import Vue from 'vue';
import { PropType } from 'vue';
import mixins from 'vue-typed-mixins';

import { E不動産種類 } from '@/openapi/enum';

import ElDatePickerMixin from '@/mixins/ElDatePickerMixin';
import InputableTextBaseMixin, { InputType } from '@/entries/user/mixins/InputableTextBaseMixin';

import { type不動産価格Keys, 保有不動産EditItem } from '@/classes/service/分析/保有不動産Service';

export const InputableTextMixin = Vue.extend({
  name: 'InputableTextMixin',

  data(): {
    itInputType: typeof InputType;
  } {
    return {
      itInputType: InputType,
    };
  },
});

export default mixins(ElDatePickerMixin, InputableTextMixin, InputableTextBaseMixin).extend({
  name: 'C保有不動産EditRow',

  props: {
    isNew: {
      type: Boolean,
      default: false,
    },
    editItem: {
      type: Object as PropType<保有不動産EditItem>,
      required: true,
    },
    固定価格種類Keys: {
      type: Array as PropType<string[]>,
      required: true,
    },
  },

  data(): {
    e不動産種類: typeof E不動産種類;
    type不動産価格Keys: typeof type不動産価格Keys;
    isActive: boolean;
    activePriceKey: string | null;
  } {
    return {
      e不動産種類: E不動産種類,
      type不動産価格Keys: type不動産価格Keys,
      isActive: false,
      activePriceKey: null,
    };
  },

  methods: {
    async focus(価格種類key: string, type不動産価格Key: string): Promise<void> {
      if (this.isActive) return;
      this.isActive = true;
      this.activePriceKey = `${価格種類key}-${type不動産価格Key}`;
      await this.$nextTick();
      const refKey = `${価格種類key}-${type不動産価格Key}`;
      const inputRef = this.$refs[refKey];
      if (inputRef) {
        if (Array.isArray(inputRef)) {
          const firstInputRef = inputRef[0] as Vue;
          if (firstInputRef && firstInputRef.$el && firstInputRef.$el.querySelector('input')) {
            (firstInputRef.$el.querySelector('input') as HTMLInputElement).focus();
          }
        } else {
          const singleInputRef = inputRef as Vue;
          if (singleInputRef && singleInputRef.$el && singleInputRef.$el.querySelector('input')) {
            (singleInputRef.$el.querySelector('input') as HTMLInputElement).focus();
          }
        }
      }
    },
    isMinus(value: string | number): boolean {
      switch (this.type) {
        case InputType.integer:
        case InputType.number:
          return (value as number) < 0;
        default:
          return false;
      }
    },
    save(isNew: boolean): void {
      this.$emit('save', isNew);
    },
    clear(): void {
      this.$emit('clear');
    },
  },
});
